import { useState, useEffect } from "react";
import { sbListarAlmacenes, sbCrearAlmacen, sbActualizarModulos, sbActualizarAlmacen } from '../services/superadmin';
import { Inp } from './ui/FormControls';

const MODULOS_DEF = [
  { key: 'almacen', label: 'Almacén / Flota (equipos)' },
  { key: 'reservas', label: 'Reserva de equipos' },
  { key: 'flota', label: 'Flota' },
  { key: 'appcc', label: 'APPCC' },
  { key: 'contenedor_sdc', label: 'Contenedor SDC' },
  { key: 'documentos', label: 'Documentos' },
  { key: 'historial', label: 'Historial' },
  { key: 'bot_admin', label: 'Chat IA (responsable)' },
  { key: 'registro_llegadas', label: 'Registro de llegadas (QR operador)' },
  { key: 'entradas', label: 'Internacional: Entradas camiones' },
  { key: 'salidas', label: 'Internacional: Salidas contenedores' },
  { key: 'fotos_contenedor', label: 'Internacional: Fotos contenedor' },
  { key: 'facturacion', label: 'Internacional: Facturación' },
  { key: 'inventario', label: 'Internacional: Inventario/Stock' },
  { key: 'pedidos', label: 'Internacional: Pedidos' },
  { key: 'archivo', label: 'Internacional: Archivo documental' },
  { key: 'kpis', label: 'Internacional: KPIs' },
];

const NUEVO_ALMACEN_INICIAL = {
  nombre: "", siglas: "", color: "#0ea5e9",
  patron: "multi",
  email_admin: "", password_admin: "",
  email_operario: "", password_operario: "",
  email_operador: "", password_operador: "",
};

// ── SUPERADMIN: gestión de clientes (almacenes) ─────────────────
export const MasterAlmacenesSection = () => {
  const [almacenes, setAlmacenes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [modalNuevo, setModalNuevo] = useState(false);
  const [nuevo, setNuevo] = useState(NUEVO_ALMACEN_INICIAL);
  const [guardandoNuevo, setGuardandoNuevo] = useState(false);
  const [errorNuevo, setErrorNuevo] = useState("");

  const [modalModulos, setModalModulos] = useState(null);
  const [modulosForm, setModulosForm] = useState({});
  const [guardandoModulos, setGuardandoModulos] = useState(false);
  const [errorModulos, setErrorModulos] = useState("");

  const [modalEditar, setModalEditar] = useState(null);
  const [editarForm, setEditarForm] = useState({ nombre: "", siglas: "", color: "#0ea5e9" });
  const [guardandoEditar, setGuardandoEditar] = useState(false);
  const [errorEditar, setErrorEditar] = useState("");

  const [toggleLoadingId, setToggleLoadingId] = useState(null);
  const [confirmToggle, setConfirmToggle] = useState(null);
  const [errorToggle, setErrorToggle] = useState("");

  const cargar = async () => {
    setLoading(true);
    setError("");
    try {
      const data = await sbListarAlmacenes();
      setAlmacenes(data.almacenes || []);
    } catch (e) {
      setError(e.message || "Error al cargar almacenes.");
    }
    setLoading(false);
  };

  useEffect(() => { cargar(); }, []);

  const abrirNuevo = () => { setNuevo(NUEVO_ALMACEN_INICIAL); setErrorNuevo(""); setModalNuevo(true); };

  const crearAlmacen = async () => {
    if (!nuevo.nombre.trim() || !nuevo.siglas.trim()) {
      setErrorNuevo("Rellena nombre y siglas.");
      return;
    }
    const cuentas = nuevo.patron === "multi"
      ? [nuevo.email_admin, nuevo.password_admin, nuevo.email_operario, nuevo.password_operario, nuevo.email_operador, nuevo.password_operador]
      : [nuevo.email_operario, nuevo.password_operario];
    if (cuentas.some(c => !c || !c.trim())) {
      setErrorNuevo(nuevo.patron === "multi" ? "Rellena email y contraseña de admin, operario y operador." : "Rellena email y contraseña de la cuenta única.");
      return;
    }
    const passwords = nuevo.patron === "multi" ? [nuevo.password_admin, nuevo.password_operario, nuevo.password_operador] : [nuevo.password_operario];
    if (passwords.some(p => p.length < 6)) {
      setErrorNuevo("Las contraseñas deben tener al menos 6 caracteres.");
      return;
    }
    setGuardandoNuevo(true);
    setErrorNuevo("");
    try {
      await sbCrearAlmacen(nuevo);
      setModalNuevo(false);
      cargar();
    } catch (e) {
      setErrorNuevo(e.message || "Error al crear el almacén.");
    }
    setGuardandoNuevo(false);
  };

  const abrirModulos = (almacen) => { setModalModulos(almacen); setModulosForm(almacen.modulos || {}); setErrorModulos(""); };

  const guardarModulos = async () => {
    setGuardandoModulos(true);
    setErrorModulos("");
    try {
      await sbActualizarModulos(modalModulos.id, modulosForm);
      setModalModulos(null);
      cargar();
    } catch (e) {
      setErrorModulos(e.message || "Error al guardar los módulos.");
    }
    setGuardandoModulos(false);
  };

  const abrirEditar = (almacen) => {
    setModalEditar(almacen);
    setEditarForm({ nombre: almacen.nombre || "", siglas: almacen.siglas || "", color: almacen.color || "#0ea5e9" });
    setErrorEditar("");
  };

  const guardarEditar = async () => {
    if (!editarForm.nombre.trim() || !editarForm.siglas.trim()) {
      setErrorEditar("Rellena nombre y siglas.");
      return;
    }
    setGuardandoEditar(true);
    setErrorEditar("");
    try {
      await sbActualizarAlmacen(modalEditar.id, editarForm);
      setModalEditar(null);
      cargar();
    } catch (e) {
      setErrorEditar(e.message || "Error al guardar los cambios.");
    }
    setGuardandoEditar(false);
  };

  const pedirConfirmacionToggle = (almacen) => { setConfirmToggle(almacen); setErrorToggle(""); };

  const confirmarToggle = async () => {
    const almacen = confirmToggle;
    const activar = almacen.activo === false;
    setToggleLoadingId(almacen.id);
    setErrorToggle("");
    try {
      await sbActualizarAlmacen(almacen.id, { activo: activar });
      setConfirmToggle(null);
      cargar();
    } catch (e) {
      setErrorToggle(e.message || "Error al cambiar el estado del almacén.");
    }
    setToggleLoadingId(null);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="font-bold text-gray-800 text-lg">Clientes (almacenes)</h2>
        <button onClick={abrirNuevo} className="bg-blue-600 text-white text-sm font-bold px-4 py-2 rounded-xl hover:bg-blue-700">+ Nuevo cliente</button>
      </div>

      {loading && <p className="text-sm text-gray-500">Cargando...</p>}
      {error && <p className="text-sm text-red-600 font-semibold">{error}</p>}

      {!loading && !error && (
        <div className="bg-white rounded-xl shadow overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-500 text-xs uppercase">
              <tr>
                <th className="text-left px-4 py-2">Nombre</th>
                <th className="text-left px-4 py-2">Siglas</th>
                <th className="text-left px-4 py-2">Estado</th>
                <th className="text-left px-4 py-2">Módulos activos</th>
                <th className="text-right px-4 py-2">Acciones</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {almacenes.map(a => (
                <tr key={a.id} className={a.activo === false ? "opacity-60" : ""}>
                  <td className="px-4 py-3 font-semibold text-gray-800">{a.nombre}</td>
                  <td className="px-4 py-3">
                    <span style={{ background: a.color || "#6b7280" }} className="text-white text-xs font-bold px-2 py-1 rounded-md">{a.siglas}</span>
                  </td>
                  <td className="px-4 py-3">
                    <span className={`text-xs font-bold px-2 py-1 rounded-full ${a.activo === false ? "bg-red-100 text-red-700" : "bg-green-100 text-green-700"}`}>{a.activo === false ? "Inactivo" : "Activo"}</span>
                  </td>
                  <td className="px-4 py-3 text-gray-600">{MODULOS_DEF.filter(m => a.modulos?.[m.key] === true).length} / {MODULOS_DEF.length}</td>
                  <td className="px-4 py-3 text-right space-x-3 whitespace-nowrap">
                    <button onClick={() => abrirEditar(a)} className="text-blue-600 hover:text-blue-800 text-xs font-bold">Editar</button>
                    <button onClick={() => abrirModulos(a)} className="text-blue-600 hover:text-blue-800 text-xs font-bold">Módulos</button>
                    <button onClick={() => pedirConfirmacionToggle(a)} disabled={toggleLoadingId === a.id} className={`text-xs font-bold disabled:opacity-40 ${a.activo === false ? "text-green-600 hover:text-green-800" : "text-red-600 hover:text-red-800"}`}>
                      {toggleLoadingId === a.id ? "..." : a.activo === false ? "Activar" : "Desactivar"}
                    </button>
                  </td>
                </tr>
              ))}
              {almacenes.length === 0 && (
                <tr><td colSpan={5} className="px-4 py-6 text-center text-gray-400">No hay almacenes todavía.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {modalNuevo && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-5 space-y-3 max-h-[85vh] overflow-y-auto">
            <h3 className="font-bold text-gray-800">Nuevo cliente</h3>
            <Inp label="Nombre del almacén" value={nuevo.nombre} onChange={v => setNuevo(n => ({ ...n, nombre: v }))} placeholder="Ej: Grupo Voldis" />
            <Inp label="Siglas" value={nuevo.siglas} onChange={v => setNuevo(n => ({ ...n, siglas: v }))} placeholder="Ej: GV" />
            <div>
              <label className="text-xs font-semibold text-gray-600 uppercase">Color</label>
              <input type="color" className="w-full h-10 border rounded-lg mt-1" value={nuevo.color} onChange={e => setNuevo(n => ({ ...n, color: e.target.value }))} />
            </div>

            <div>
              <label className="text-xs font-semibold text-gray-600 uppercase">Patrón de acceso</label>
              <div className="flex gap-2 mt-1">
                <button type="button" onClick={() => setNuevo(n => ({ ...n, patron: "multi" }))} className={`flex-1 text-xs font-semibold py-2 rounded-lg border ${nuevo.patron === "multi" ? "bg-blue-600 text-white border-blue-600" : "bg-white text-gray-600 border-gray-300"}`}>Multi-rol (3 cuentas)</button>
                <button type="button" onClick={() => setNuevo(n => ({ ...n, patron: "unico" }))} className={`flex-1 text-xs font-semibold py-2 rounded-lg border ${nuevo.patron === "unico" ? "bg-blue-600 text-white border-blue-600" : "bg-white text-gray-600 border-gray-300"}`}>Usuario único (1 cuenta)</button>
              </div>
              <p className="text-xs text-gray-400 mt-1">{nuevo.patron === "multi" ? "Como Voldis/Demo: cuentas separadas de admin, operario y operador." : "Como Internacional: una sola cuenta de operario para todo."}</p>
            </div>

            {nuevo.patron === "multi" && (
              <>
                <p className="text-xs font-bold text-gray-500 pt-1">Cuenta admin (responsable)</p>
                <Inp label="Email" value={nuevo.email_admin} onChange={v => setNuevo(n => ({ ...n, email_admin: v }))} placeholder="admin@cliente.com" />
                <Inp label="Contraseña" type="password" value={nuevo.password_admin} onChange={v => setNuevo(n => ({ ...n, password_admin: v }))} placeholder="Mínimo 6 caracteres" />
                <p className="text-xs font-bold text-gray-500 pt-1">Cuenta operario</p>
                <Inp label="Email" value={nuevo.email_operario} onChange={v => setNuevo(n => ({ ...n, email_operario: v }))} placeholder="operario@cliente.com" />
                <Inp label="Contraseña" type="password" value={nuevo.password_operario} onChange={v => setNuevo(n => ({ ...n, password_operario: v }))} placeholder="Mínimo 6 caracteres" />
                <p className="text-xs font-bold text-gray-500 pt-1">Cuenta operador (transportista)</p>
                <Inp label="Email" value={nuevo.email_operador} onChange={v => setNuevo(n => ({ ...n, email_operador: v }))} placeholder="operador@cliente.com" />
                <Inp label="Contraseña" type="password" value={nuevo.password_operador} onChange={v => setNuevo(n => ({ ...n, password_operador: v }))} placeholder="Mínimo 6 caracteres" />
              </>
            )}
            {nuevo.patron === "unico" && (
              <>
                <p className="text-xs font-bold text-gray-500 pt-1">Cuenta única (operario)</p>
                <Inp label="Email" value={nuevo.email_operario} onChange={v => setNuevo(n => ({ ...n, email_operario: v }))} placeholder="cliente@warehauseplan.com" />
                <Inp label="Contraseña" type="password" value={nuevo.password_operario} onChange={v => setNuevo(n => ({ ...n, password_operario: v }))} placeholder="Mínimo 6 caracteres" />
              </>
            )}

            {errorNuevo && <p className="text-xs text-red-600 font-semibold">{errorNuevo}</p>}
            <div className="flex gap-2 pt-2">
              <button onClick={() => setModalNuevo(false)} className="flex-1 bg-gray-100 text-gray-700 font-bold py-2 rounded-xl hover:bg-gray-200">Cancelar</button>
              <button onClick={crearAlmacen} disabled={guardandoNuevo} className="flex-1 bg-blue-600 text-white font-bold py-2 rounded-xl hover:bg-blue-700 disabled:opacity-40">{guardandoNuevo ? "Creando..." : "Crear"}</button>
            </div>
          </div>
        </div>
      )}

      {modalModulos && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-5 space-y-3 max-h-[85vh] overflow-y-auto">
            <h3 className="font-bold text-gray-800">Módulos — {modalModulos.nombre}</h3>
            <div className="divide-y border rounded-lg overflow-hidden">
              {MODULOS_DEF.map(m => (
                <label key={m.key} className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-50">
                  <input type="checkbox" checked={modulosForm[m.key] === true} className="w-4 h-4 accent-blue-500"
                    onChange={() => setModulosForm(f => ({ ...f, [m.key]: !(f[m.key] === true) }))} />
                  <span className="text-sm text-gray-700">{m.label}</span>
                </label>
              ))}
            </div>
            {errorModulos && <p className="text-xs text-red-600 font-semibold">{errorModulos}</p>}
            <div className="flex gap-2 pt-2">
              <button onClick={() => setModalModulos(null)} className="flex-1 bg-gray-100 text-gray-700 font-bold py-2 rounded-xl hover:bg-gray-200">Cancelar</button>
              <button onClick={guardarModulos} disabled={guardandoModulos} className="flex-1 bg-blue-600 text-white font-bold py-2 rounded-xl hover:bg-blue-700 disabled:opacity-40">{guardandoModulos ? "Guardando..." : "Guardar"}</button>
            </div>
          </div>
        </div>
      )}

      {modalEditar && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-5 space-y-3">
            <h3 className="font-bold text-gray-800">Editar cliente</h3>
            <Inp label="Nombre del almacén" value={editarForm.nombre} onChange={v => setEditarForm(f => ({ ...f, nombre: v }))} placeholder="Ej: Grupo Voldis" />
            <Inp label="Siglas" value={editarForm.siglas} onChange={v => setEditarForm(f => ({ ...f, siglas: v }))} placeholder="Ej: GV" />
            <div>
              <label className="text-xs font-semibold text-gray-600 uppercase">Color</label>
              <input type="color" className="w-full h-10 border rounded-lg mt-1" value={editarForm.color} onChange={e => setEditarForm(f => ({ ...f, color: e.target.value }))} />
            </div>
            {errorEditar && <p className="text-xs text-red-600 font-semibold">{errorEditar}</p>}
            <div className="flex gap-2 pt-2">
              <button onClick={() => setModalEditar(null)} className="flex-1 bg-gray-100 text-gray-700 font-bold py-2 rounded-xl hover:bg-gray-200">Cancelar</button>
              <button onClick={guardarEditar} disabled={guardandoEditar} className="flex-1 bg-blue-600 text-white font-bold py-2 rounded-xl hover:bg-blue-700 disabled:opacity-40">{guardandoEditar ? "Guardando..." : "Guardar"}</button>
            </div>
          </div>
        </div>
      )}

      {confirmToggle && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-sm p-5 space-y-3">
            <h3 className="font-bold text-gray-800">{confirmToggle.activo === false ? "Reactivar cliente" : "Desactivar cliente"}</h3>
            <p className="text-sm text-gray-600">
              {confirmToggle.activo === false
                ? <>¿Reactivar <strong>{confirmToggle.nombre}</strong>? Sus cuentas podrán volver a iniciar sesión.</>
                : <>¿Desactivar <strong>{confirmToggle.nombre}</strong>? Se bloquearán todas sus cuentas (admin, operario, operador) y no podrán iniciar sesión hasta que lo reactives.</>}
            </p>
            {errorToggle && <p className="text-xs text-red-600 font-semibold">{errorToggle}</p>}
            <div className="flex gap-2 pt-2">
              <button onClick={() => setConfirmToggle(null)} className="flex-1 bg-gray-100 text-gray-700 font-bold py-2 rounded-xl hover:bg-gray-200">Cancelar</button>
              <button onClick={confirmarToggle} disabled={toggleLoadingId === confirmToggle.id} className={`flex-1 text-white font-bold py-2 rounded-xl disabled:opacity-40 ${confirmToggle.activo === false ? "bg-green-600 hover:bg-green-700" : "bg-red-600 hover:bg-red-700"}`}>
                {toggleLoadingId === confirmToggle.id ? "Guardando..." : confirmToggle.activo === false ? "Reactivar" : "Desactivar"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
